import * as React from 'react';
import { connect } from 'react-redux';

import { push } from 'connected-react-router';

export default function mapHistoryPush(ComposedComponent: React.ComponentType<any>) {
  class HistoryPush extends React.Component {
    public render() {
      return <ComposedComponent {...this.props} />;
    }
  }

  const mapDispatchToProps = (dispatch: any) => ({
    pushPath: (path) => dispatch(push(path)),
  });

  return connect(null, mapDispatchToProps)(HistoryPush);
}
